import { validateEnumTranslations } from '../../safety_checks';
import { SITE_EVENT_NAMES, type SiteEventName } from '../tracking/site-events';

/**
 * Libellés des événements de suivi des sites clients (`SITE_EVENTS`), tels qu'ils sont montrés
 * au pro dans les réglages « Suivi » de son site. Les NOMS d'événements, eux, sont un contrat
 * public pour les agences : ils ne se traduisent pas.
 */
export const TRANSLATE_KEY_SITE_EVENT = 'SITE_EVENT_';

export const SiteEventTranslation: { 'fr-FR': { [K in SiteEventName as `SITE_EVENT_${K}`]: string } } = {
  'fr-FR': {
    SITE_EVENT_generate_lead: 'Formulaire envoyé (message ou demande de rappel)',
    SITE_EVENT_booking_confirmed: 'Rendez-vous ou course confirmé',
    SITE_EVENT_purchase: 'Achat d’une carte cadeau ou d’un forfait',
    SITE_EVENT_phone_click: 'Clic sur le numéro de téléphone',
    SITE_EVENT_email_click: 'Clic sur l’adresse e-mail',
    SITE_EVENT_whatsapp_click: 'Clic sur WhatsApp',
    SITE_EVENT_newsletter_subscribe: 'Inscription à la newsletter',
    SITE_EVENT_add_to_cart: 'Prestation ajoutée au panier',
    SITE_EVENT_booking_started: 'Tunnel de réservation ouvert',
    SITE_EVENT_booking_step: 'Étape du tunnel de réservation affichée',
    SITE_EVENT_booking_slot_selected: 'Créneau choisi',
    SITE_EVENT_booking_prereserved: 'Créneau bloqué avant paiement',
    SITE_EVENT_booking_abandoned: 'Réservation abandonnée',
    SITE_EVENT_begin_checkout: 'Réservation commencée avec une sélection',
  },
};

validateEnumTranslations(
  Object.fromEntries(SITE_EVENT_NAMES.map((name): [string, string] => [name, name])),
  SiteEventTranslation,
  TRANSLATE_KEY_SITE_EVENT,
  true,
);
